import { GanCubeCommand, GanCubeConnection, GanCubeEvent, now } from "gan-web-bluetooth";
import { Observable, Subject } from 'rxjs';
import {mathlib} from "../../hardware/mathlib";
import { BluetoothDeviceWithMAC } from "./qiyiUtils";


export class MoYu32CubeConnection implements GanCubeConnection {

    device: BluetoothDeviceWithMAC;
    stateReadCharacteristic: BluetoothRemoteGATTCharacteristic;
    stateWriteCharacteristic: BluetoothRemoteGATTCharacteristic;    
    decoder: any;
    
    events$: Subject<GanCubeEvent>;

    private deviceNameInternal: string = "";
    private curCubie: mathlib.CubieCube = new mathlib.CubieCube();
    private prevCubie: mathlib.CubieCube = new mathlib.CubieCube();
    private prevMoveCountInternal: number = -1;
    private moveCountInternal: number = -1;
    private allMoves: string[] = [];
    private prevMoves: string[] = [];
    private lastTs: number = 0;
    private batteryLevel: number = 0;
    private facelets: string = "";
	private timeOffs: number[] = [];

    private deviceTime = 0;
	private deviceTimeOffset = 0;
	
    private constructor(
        device: BluetoothDeviceWithMAC,
        stateReadCharacteristic: BluetoothRemoteGATTCharacteristic,
        stateWriteCharacteristic: BluetoothRemoteGATTCharacteristic,
        decoder: any,
    ) {
        this.device = device;
        this.stateReadCharacteristic = stateReadCharacteristic;
        this.stateWriteCharacteristic = stateWriteCharacteristic;
        this.decoder = decoder;
        this.events$ = new Subject<GanCubeEvent>();

        this.sendCommandMessage = this.sendCommandMessage.bind(this);
        this.onStateUpdate = this.onStateUpdate.bind(this);
        this.sendSimpleRequest = this.sendSimpleRequest.bind(this);
        this.decode = this.decode.bind(this);
        this.encode = this.encode.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.parseCubeData = this.parseCubeData.bind(this);
        this.parseFacelet = this.parseFacelet.bind(this);
        this.onDisconnect = this.onDisconnect.bind(this);
        this.disconnect = this.disconnect.bind(this);
        this.updateMoveTimes = this.updateMoveTimes.bind(this);
        
    }

    public static async create(
        device: BluetoothDeviceWithMAC,
        stateReadCharacteristic: BluetoothRemoteGATTCharacteristic,
        stateWriteCharacteristic: BluetoothRemoteGATTCharacteristic,
        encrypter: any
    ): Promise<MoYu32CubeConnection> {
        var conn = new MoYu32CubeConnection(device, stateReadCharacteristic, stateWriteCharacteristic, encrypter);
        conn.device.addEventListener('gattserverdisconnected', conn.onDisconnect);
        conn.stateReadCharacteristic.addEventListener('characteristicvaluechanged', conn.onStateUpdate);
        try {
            await conn.stateReadCharacteristic.startNotifications();
        } catch (error) {
            console.error("Failed to start notifications", error);
        }
        try {
            //await conn.sendHello(conn.device.mac || "00:00:00:00:00:00");
        } catch (error) {
            console.error("Failed to send Hello", error);
        }
       
        return conn;
    }

    get getCurrentFacelets(): string {
        return this.facelets;
    }

    get deviceName(): string {
        return this.deviceNameInternal || "WCU_MY32_XXXX";
    }

    get deviceMAC(): string {
        return this.device.mac || "00:00:00:00:00:00";
    }

    async sendSimpleRequest(opcode: number) {
		var req = mathlib.valuedArray(20, 0);
		req[0] = opcode;
		return this.sendCommandMessage(req);
	}

    decode(value: DataView<ArrayBufferLike>) {
		var ret = [];
		for (var i = 0; i < value.byteLength; i++) {
			ret[i] = value.getUint8(i);
		}
		if (this.decoder == null) {
			return ret;
		}
		var iv = this.decoder.iv || [];
		if (ret.length > 16) {
			var offset = ret.length - 16;
			var block = this.decoder.decrypt(ret.slice(offset));
			for (var i = 0; i < 16; i++) {
				ret[i + offset] = block[i] ^ (~~iv[i]);
			}
		}
		ret = this.decoder.decrypt(ret);
		for (var i = 0; i < 16; i++) {
			ret[i] ^= (~~iv[i]);
		}
		return ret;
	}

    encode(ret: number[]) {
		if (this.decoder == null) {
			return ret;
		}
		var iv = this.decoder.iv || [];
		for (var i = 0; i < 16; i++) {
			ret[i] ^= ~~iv[i];
		}
		ret = this.decoder.encrypt(ret);
		if (ret.length > 16) {
			var offset = ret.length - 16;
			var block = ret.slice(offset);
			for (var i = 0; i < 16; i++) {
				block[i] ^= ~~iv[i];
			}
			block = this.decoder.encrypt(block);
			for (var i = 0; i < 16; i++) {
				ret[i + offset] = block[i];
			}
		}
		return ret;
	}

    async sendCommandMessage(message: number[]): Promise<void> {
        var encodedReq = this.encode(message.slice());
		return this.stateWriteCharacteristic.writeValue(new Uint8Array(encodedReq).buffer);
    }

    onStateUpdate = (evt: Event) => {
        var characteristic = evt.target as BluetoothRemoteGATTCharacteristic;
        var eventMessage = characteristic.value;

        var value = this.decode(eventMessage!)

        for (var i = 0; i < value.length; i++) {
			value[i] = (value[i] + 256).toString(2).slice(1);
		}
		value = value.join('');
		var msgType = parseInt(value.slice(0, 8), 2);

        console.log(msgType);

        this.parseCubeData(msgType, value);
    }
    
    parseFacelet(faceletBits: string) : string {
		var state = [];
		var faces = [2, 5, 0, 3, 4, 1] // parse in order URFDLB instead of FBUDLR
		for (var i = 0; i < 6; i += 1) {
			var face = faceletBits.slice(faces[i] * 24, 24 + faces[i] * 24);
			for (var j = 0; j < 8; j += 1) {
				state.push("FBUDLR".charAt(parseInt(face.slice(j * 3, 3 + j * 3), 2)));
				if (j == 3) {
					state.push("FBUDLR".charAt(faces[i]));
				}
			}
		}
        this.facelets = state.join("");
		return this.facelets;
	}
    
    updateMoveTimes(locTime: number) {
		var moveDiff = (this.moveCountInternal - this.prevMoveCountInternal) & 0xff;
		
        this.prevMoveCountInternal = this.moveCountInternal;
		if (moveDiff > this.prevMoves.length) {
			moveDiff = this.prevMoves.length;
		}
		var calcTs = this.deviceTime + this.deviceTimeOffset;
		for (var i = moveDiff - 1; i >= 0; i--) {
			calcTs += this.timeOffs[i];
		}
		if (!this.deviceTime || Math.abs(locTime - calcTs) > 2000) {
			this.deviceTime += locTime - calcTs;
		}
		for (var i = moveDiff - 1; i >= 0; i--) {
			//var m = "URFDLB".indexOf(this.prevMoves[i][0]) * 3 + " 2'".indexOf(this.prevMoves[i][1]);
			//mathlib.CubieCube.CubeMult(this.prevCubie, mathlib.CubieCube.moveCube[m], this.curCubie);
			this.deviceTime += this.timeOffs[i];
			//GiikerCube.callback(curCubie.toFaceCube(), prevMoves.slice(i), [deviceTime, i == 0 ? locTime : null], deviceName);
			//var tmp = curCubie;
			//curCubie = prevCubie;
			//prevCubie = tmp;
			//giikerutil.log('[Moyu32Cube] move', prevMoves[i], timeOffs[i]);
		}
		this.deviceTimeOffset = locTime - this.deviceTime;
	}

    parseCubeData(msgType: number, value: string) {
        var locTime = Date.now();

        if (msgType == 161) { // info
			for (var i = 0; i < 8; i++){
                this.deviceNameInternal += String.fromCharCode(parseInt(value.slice(8 + i * 8, 16 + i * 8), 2));
            }
            var hardwareVersion = parseInt(value.slice(88, 96), 2) + "." + parseInt(value.slice(96, 104), 2);
            var softwareVersion = parseInt(value.slice(72, 80), 2) + "." + parseInt(value.slice(80, 88), 2);
			
		} else if (msgType == 163) { // state (facelets)
			if (this.prevMoveCountInternal == -1) { // we only care about the initial cube state, ignore any other state messages
				this.prevMoveCountInternal = parseInt(value.slice(152, 160), 2);
            }
            this.facelets = this.parseFacelet(value.slice(8, 152));
            const [cp, co, ep, eo] = fromKociembaFacelets(this.facelets);
            //initCubeState();
            this.events$.next({
                type: "FACELETS",
                serial: 0,
                timestamp: locTime,
                facelets: this.facelets,
                state: {
                    CP: cp,
                    CO: co,
                    EP: ep,
                    EO: eo
                }
            })
            
		} else if (msgType == 164) { // battery level
			this.batteryLevel = parseInt(value.slice(8, 16), 2);
			//giikerutil.updateBattery([batteryLevel, deviceName]);
		} else if (msgType == 165) { // move
			this.moveCountInternal = parseInt(value.slice(88, 96), 2);
			if (this.moveCountInternal == this.prevMoveCountInternal || this.prevMoveCountInternal == -1) {
				return;
			}
			this.timeOffs = [];
			this.prevMoves = [];
			let invalidMove = false;
			for (var i = 0; i < 5; i++) {
				var m = parseInt(value.slice(96 + i * 5, 101 + i * 5), 2);
				this.timeOffs[i] = parseInt(value.slice(8 + i * 16, 24 + i * 16), 2);
				this.prevMoves[i] = "FBUDLR".charAt(m >> 1) + " '".charAt(m & 1);
				if (m >= 12) {
					this.prevMoves[i] = "U ";
					invalidMove = true;
				}
			}

			if (!invalidMove) {
                this.updateMoveTimes(locTime);

                this.events$.next({
                    type: "MOVE",
                    cubeTimestamp: this.deviceTime,
                    direction: 1,
                    face: 1,
                    move: this.prevMoves[0].trim(),
                    timestamp: locTime,
                    serial: 1,
                    localTimestamp: locTime
                }); 
			}
		// } else if (msgType == 171) { // gyro
		}
    }

    sendMessage(content: string | any[]) : Promise<void> {
        if (!this.stateWriteCharacteristic) {
            return Promise.resolve()// : Promise.reject();
        }
        var msg = [0xfe];
        msg.push(4 + content.length); // length = 1 (op) + cont.length + 2 (crc)
        for (var i = 0; i < content.length; i++) {
            msg.push(content[i]);
        }
        var crc = crc16modbus(msg);
        msg.push(crc & 0xff, crc >> 8);
        var npad = (16 - msg.length % 16) % 16;
        for (var i = 0; i < npad; i++) {
            msg.push(0);
        }
        var encMsg = [];
        
        for (var i = 0; i < msg.length; i += 16) {
            var block = msg.slice(i, i + 16);
            this.decoder.encrypt(block);
            for (var j = 0; j < 16; j++) {
                encMsg[i + j] = block[j];
            }
        }
        return this.stateWriteCharacteristic.writeValue(new Uint8Array(encMsg).buffer);
    }

    onDisconnect = async (): Promise<any> => {
        this.device.removeEventListener('gattserverdisconnected', this.onDisconnect);
        this.stateReadCharacteristic.removeEventListener('characteristicvaluechanged', this.onStateUpdate);
        this.events$.next({ timestamp: now(), type: "DISCONNECT" });
        this.events$.unsubscribe();
        return this.stateReadCharacteristic.stopNotifications().catch(() => { });
    }

    async sendCubeCommand(command: GanCubeCommand): Promise<void> {
        switch(command.type){
            case "REQUEST_BATTERY":
                return this.sendSimpleRequest(164);
            case "REQUEST_FACELETS":
                return this.sendSimpleRequest(163);
            case "REQUEST_HARDWARE":
                return this.sendSimpleRequest(161);
            case "REQUEST_RESET":
                break;
            default:
                break;
        }
    }

    async disconnect(): Promise<void> {
        await this.onDisconnect();
        if (this.device.gatt?.connected) {
            this.device.gatt?.disconnect();
        }
    }

}

function crc16modbus(data: string | any[]) {
    var crc = 0xFFFF;
    for (var i = 0; i < data.length; i++) {
        crc ^= data[i];
        for (var j = 0; j < 8; j++) {
            crc = (crc & 0x1) > 0 ? (crc >> 1) ^ 0xa001 : crc >> 1;
        }
    }
    return crc;
}


// Example maps. Make sure these match your system!
const CORNER_FACELET_MAP = [
    [8, 9, 20],   // UFR
    [6, 18, 38],  // URB
    [0, 36, 47],  // UBL
    [2, 45, 11],  // ULF
    [29, 26, 15], // DFR
    [27, 44, 24], // DRB
    [33, 53, 42], // DBL
    [35, 17, 51], // DLF
];

const EDGE_FACELET_MAP = [
    [5, 10],  // UR
    [7, 19],  // UF
    [3, 37],  // UL
    [1, 46],  // UB
    [32, 16], // DR
    [28, 25], // DF
    [30, 43], // DL
    [34, 52], // DB
    [23, 12], // FR
    [21, 41], // FL
    [50, 39], // BL
    [48, 14], // BR
];

const CORNER_COLORS = [
    ['U','R','F'],
    ['U','B','R'],
    ['U','L','B'],
    ['U','F','L'],
    ['D','F','R'],
    ['D','R','B'],
    ['D','B','L'],
    ['D','L','F'],
];
const EDGE_COLORS = [
    ['U','R'],
    ['U','F'],
    ['U','L'],
    ['U','B'],
    ['D','R'],
    ['D','F'],
    ['D','L'],
    ['D','B'],
    ['F','R'],
    ['F','L'],
    ['B','L'],
    ['B','R'],
];

function fromKociembaFacelets(facelets: string) {
    // Setup color to face index
    const colorToFaceIdx: Record<string, number> = {
        U: 0, R: 1, F: 2, D: 3, L: 4, B: 5
    };

    let cp = new Array(8);
    let co = new Array(8);
    let ep = new Array(12);
    let eo = new Array(12);

    // Corners
    for (let i = 0; i < 8; i++) {
        const f = CORNER_FACELET_MAP[i];
        const stickers = [facelets[f[0]], facelets[f[1]], facelets[f[2]]];
        let found = false;
        for (let j = 0; j < 8; j++) {
            for (let ori = 0; ori < 3; ori++) {
                // Rotate CORNER_COLORS[j] by ori
                if (
                    stickers[0] === CORNER_COLORS[j][ori] &&
                    stickers[1] === CORNER_COLORS[j][(ori + 1) % 3] &&
                    stickers[2] === CORNER_COLORS[j][(ori + 2) % 3]
                ) {
                    cp[i] = j;
                    co[i] = ori;
                    found = true;
                    break;
                }
            }
            if (found) break;
        }
        if (!found) throw new Error(`Invalid corner at position ${i}: ${stickers.join('')}`);
    }

    // Edges
    for (let i = 0; i < 12; i++) {
        const f = EDGE_FACELET_MAP[i];
        const stickers = [facelets[f[0]], facelets[f[1]]];
        let found = false;
        for (let j = 0; j < 12; j++) {
            // Normal orientation
            if (stickers[0] === EDGE_COLORS[j][0] && stickers[1] === EDGE_COLORS[j][1]) {
                ep[i] = j;
                eo[i] = 0;
                found = true;
                break;
            }
            // Flipped orientation
            if (stickers[0] === EDGE_COLORS[j][1] && stickers[1] === EDGE_COLORS[j][0]) {
                ep[i] = j;
                eo[i] = 1;
                found = true;
                break;
            }
        }
        if (!found) throw new Error(`Invalid edge at position ${i}: ${stickers.join('')}`);
    }

    return [cp, co, ep, eo];
}